import Vue from 'vue';
import Vuex from 'vuex';


Vue.use(Vuex);
const store = new Vuex.Store({
	state: {
		token: '',
		sid:'',
		startTime: '',
		expires_in: '',
		baseInfo:JSON.parse(sessionStorage.getItem('baseInfo')) || [],
		limitPath:JSON.parse(sessionStorage.getItem('limitPath')) || [],
    viewButton:JSON.parse(sessionStorage.getItem('viewButton')) || [],
    staticData:JSON.parse(sessionStorage.getItem('staticData')) || {},
    positionId:JSON.parse(sessionStorage.getItem('positionId')) || '',
    step:JSON.parse(sessionStorage.getItem('step')) || '',
    newCaseId:JSON.parse(sessionStorage.getItem('newCaseId')) || '',
    restartCase:JSON.parse(sessionStorage.getItem('restartCase')) || '',

	},
	mutations: {
		//更新用户信息
		updateUserInfo(state, newUserInfo) {
			state.userInfo = newUserInfo;
		},
		//登录
		login(state,Loging){
			state.Loging = Loging
		},
		//退出
		logout(state,Loging){
			state.Loging = false
		},
		//导航守卫
		setToken(state, { expires_in, token, sid, startTime}) {
			state.expires_in = expires_in;
			state.token = token;
			state.sid = sid;
			state.startTime = startTime;
			// console.log(state.token);
		},
		//基本信息
		base(state,baseInfo){
			sessionStorage.setItem('baseInfo',JSON.stringify(baseInfo))
			state.baseInfo=baseInfo;
		},
		//修改病例的限制
		limitCase(state,path){
			sessionStorage.setItem('limitPath',JSON.stringify(path))
			state.limitPath=path;
		},
        //视图权限
        viewInfo(state,buttonId){
          sessionStorage.setItem('viewButton',JSON.stringify(buttonId))
          state.viewButton=buttonId;
        },
        //静态资源
        staticRes(state,staticData){
          sessionStorage.setItem('staticData',JSON.stringify(staticData))
          state.staticData=staticData;
        },
        //登录用户id
        positionId(state,positionId){
            sessionStorage.setItem('positionId',JSON.stringify(positionId))
            state.positionId=positionId;
        },
        //新建病例当前到哪一步了
        createCaseStep(state,step){
            sessionStorage.setItem('step',JSON.stringify(step))
            state.step=step;
        },
        //新建病例caseId
        newCaseId(state,newCaseId){
            sessionStorage.setItem('newCaseId',JSON.stringify(newCaseId))
            state.newCaseId=newCaseId;
        },
        //病例重启标识
        restartCase(state,restartCase){
            sessionStorage.setItem('restartCase',JSON.stringify(restartCase))
            state.restartCase=restartCase;
        },
	},
	// actions:{
	// 	sendtoken({ commit }){
	// 		return new Promise((resolve, reject) => {
	// 			setTimeout(() => {
	// 				commit('sendtoken')
	// 				resolve()
	// 			},1000)
	// 		})
	// 	}
	// }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js